import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LevelTwoSectionEdit = ({ data, onChange, errors, videoUrl = '', onVideoUrlChange, handleSaveLevel, handleCancelLevel, levelSaving, levelSaved, hasUnsavedChanges }) => {
  return (
    <div className="space-y-4">
      {/* Mux Video URL */}
      <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6">
        <h3 className="text-xl font-heading font-semibold text-white mb-4 flex items-center space-x-2">
          <Icon name="Film" size={24} className="text-blue-200" />
          <span>Level 2 Video</span>
          {hasUnsavedChanges && (
            <span className="inline-flex items-center space-x-1 bg-amber-500 bg-opacity-20 border border-amber-400 border-opacity-50 text-amber-300 text-xs px-2 py-0.5 rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block" />
              <span>Unsaved</span>
            </span>
          )}
        </h3>
        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Mux Playback ID
          </label>
          <input
            type="text"
            value={videoUrl}
            onChange={(e) => onVideoUrlChange?.(e?.target?.value)}
            className="w-full px-4 py-2 bg-white bg-opacity-20 border border-white border-opacity-30 rounded-xl text-white placeholder-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-400"
            placeholder="e.g. DS00Spx1CV902MCtPj5WknGlR017IEmVd"
          />
          <p className="text-blue-300 text-xs mt-1">
            Enter the Mux playback_id from your Mux dashboard or the videos table. Leave blank to hide the video for this level.
          </p>
        </div>
      </div>

      <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6">
        <h3 className="text-xl font-heading font-semibold text-white mb-4 flex items-center space-x-2">
          <Icon name="Layers" size={24} className="text-blue-200" />
          <span>Level 2 Analysis</span>
          {hasUnsavedChanges && (
            <span className="inline-flex items-center space-x-1 bg-amber-500 bg-opacity-20 border border-amber-400 border-opacity-50 text-amber-300 text-xs px-2 py-0.5 rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block" />
              <span>Unsaved</span>
            </span>
          )}
        </h3>
        
        <div>
          <label className="block text-sm font-medium text-blue-100 mb-2">
            Analysis
          </label>
          <textarea
            value={data || ''}
            onChange={(e) => onChange(e?.target?.value)}
            className="w-full px-4 py-3 bg-white bg-opacity-20 border border-white border-opacity-30 rounded-xl text-white placeholder-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-400"
            placeholder="Enter Level 2 analysis..."
            rows={12}
            style={{ whiteSpace: 'pre-wrap' }}
          />
          {errors?.level2 && (
            <p className="text-red-300 text-sm mt-1">{errors?.level2}</p>
          )}
        </div>
      </div>

      {/* Per-Level Save / Cancel */}
      <div className="flex justify-end items-center space-x-3 pt-2">
        <Button
          type="button"
          variant="outline"
          onClick={() => handleCancelLevel?.('level2')}
          className="border-white border-opacity-40 text-white hover:bg-white hover:bg-opacity-10"
        >
          Cancel
        </Button>
        <Button
          type="button"
          disabled={levelSaving?.level2}
          onClick={() => handleSaveLevel?.('level2')}
          iconName={levelSaved?.level2 ? 'Check' : 'Save'}
          iconPosition="left"
          className={`bg-white text-indigo-900 hover:bg-gray-100 ${levelSaving?.level2 ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {levelSaving?.level2 ? 'Saving...' : levelSaved?.level2 ? 'Saved!' : 'Save Level 2'}
        </Button>
      </div>
    </div>
  );
};

export default LevelTwoSectionEdit;